export const theme = {
  // Colors from Ant Design token system
  colorInfo: '#1890ff',
  colorInfoHover: '#40a9ff',
  colorBgLayout: '#f0f2f5',
  text1: '#000000',
  text3: '#8c8c8c',
  brandDefault: '#1890ff',
  brandInverted: '#ffffff',
  background1Default: '#ffffff',
};

export type Theme = typeof theme;
